import { useState } from "react";
import { X } from "lucide-react";

const BASE = "https://customer-assets-m6fa6gv7.emergentagent.net/job_edu-ecosystem-14/artifacts";

export const TEACHER_SHOTS = [
  { src: `${BASE}/wwot353x_IMG_2981.webp`, label: "Home & Next Class" },
  { src: `${BASE}/0vjxxs4p_IMG_2982.webp`, label: "Class Detail & Lesson" },
  { src: `${BASE}/nh4lym6e_IMG_2984.webp`, label: "In-Class Attendance" },
  { src: `${BASE}/p62pofth_IMG_2985.webp`, label: "Lesson Plan" },
  { src: `${BASE}/7tzerk5b_IMG_2986.webp`, label: "Behaviour Feedback" },
  { src: `${BASE}/vcdt1p83_IMG_2987.webp`, label: "Assignments & Evaluation" },
  { src: `${BASE}/00tjz31h_IMG_2988.webp`, label: "To-Do List" },
  { src: `${BASE}/ukfzncsk_IMG_2991.webp`, label: "Teacher AHI — Analytical Health Index" },
  { src: `${BASE}/wnx3a3ds_IMG_2992.webp`, label: "PARTECON Communication Channel" },
];

const PhoneFrame = ({ src, label, onOpen }) => (
  <div className="shrink-0 snap-center" style={{ width: 184 }}>
    <button onClick={onOpen} data-testid={`teacher-shot-${label.split(" ")[0].toLowerCase()}`}
      className="block w-full rounded-[2rem] border-[6px] border-[#0E1117] bg-[#0E1117] shadow-[0_28px_60px_-22px_rgba(16,17,23,0.5)] overflow-hidden transition-transform duration-500 hover:-translate-y-1.5 cursor-zoom-in">
      <img src={src} alt={`PARTECON Teacher App — ${label}`} loading="lazy" className="w-full block" />
    </button>
    <p className="text-center text-[11px] text-[#6B7280] mt-3 font-medium leading-tight px-2">{label}</p>
  </div>
);

export const TeacherAppShowcase = ({ limit }) => {
  const [open, setOpen] = useState(null);
  const shots = limit ? TEACHER_SHOTS.slice(0, limit) : TEACHER_SHOTS;
  return (
    <div className="relative" data-testid="teacher-app-showcase">
      <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-3 -mx-1 px-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {shots.map((s) => <PhoneFrame key={s.label} {...s} onOpen={() => setOpen(s)} />)}
      </div>
      <div className="mt-1 flex items-center gap-2 text-[11px] text-[#9AA1AD] font-mono-accent">
        <span className="inline-block h-1 w-8 rounded-full bg-[#6366F1]/40" /> Swipe · tap any screen to expand
      </div>
      {open && (
        <div data-testid="teacher-lightbox" onClick={() => setOpen(null)}
          className="fixed inset-0 z-[100] bg-[#0A0C11]/90 backdrop-blur-sm flex flex-col items-center justify-center p-6 animate-[fadeIn_.2s_ease]">
          <button data-testid="teacher-lightbox-close" onClick={() => setOpen(null)}
            className="absolute top-5 right-5 h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors">
            <X size={20} />
          </button>
          <div onClick={(e) => e.stopPropagation()} className="rounded-[2.2rem] border-[7px] border-[#0E1117] overflow-hidden shadow-2xl max-h-[82vh]">
            <img src={open.src} alt={open.label} className="h-full w-auto max-h-[80vh] block" />
          </div>
          <p className="text-white/70 text-sm mt-4 font-medium">{open.label}</p>
        </div>
      )}
    </div>
  );
};
